import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/filter';
import {NgbModal, ModalDismissReasons, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from '../providers/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from '../../environments/environment.prod';
@Component({
  selector: 'app-my-order',
  templateUrl: './my-order.component.html',
  styleUrls: ['./my-order.component.css']
})
export class MyOrderComponent implements OnInit {
  laundering_options:any = [];
  completedData:any = [];
  pendingData:any = [];
  TIME_RANGE:any = [];
  DAYS: any = [];
  page:any = '0';
  currentUser:any = {};
  modalReference: any;
  reviewData:any = {};
  reviewOrderNo:any = '';

  constructor(private modalService: NgbModal,private auth : AuthService, private router: Router, private route: ActivatedRoute, private spinnerService: Ng4LoadingSpinnerService) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

   }

  getTIME_RANGEtoValue(id = ''){
    var count = this.TIME_RANGE.length;
    for( var i = 0; i < count; i++ )
    { 
       if( (this.TIME_RANGE[i].id).toString() == id.toString() ){
           return (this.TIME_RANGE[i].val); 
       }
    }
    return '';  
  }  

  getDAYStoValue(id = ''){
    var count = this.DAYS.length;
    for( var i = 0; i < count; i++ )
    { 
       if( (this.DAYS[i].id).toString() == id.toString() ){
           return (this.DAYS[i].value); 
       }
    }
    return '';  
  }

  getDitergenttoValue(id = ''){
    var count = ( this.laundering_options.detergents != undefined && this.laundering_options.detergents ) ? this.laundering_options.detergents.length : 0;
    for( var i = 0; i < count; i++ )
    { 
       if( (this.laundering_options.detergents[i].id).toString() == id.toString() ){
           return (this.laundering_options.detergents[i].title); 
       }
    }
    return '';  
  }

  getSoftenerstoValue(id = ''){
    var count = ( this.laundering_options.softeners != undefined && this.laundering_options.softeners ) ? this.laundering_options.softeners.length : 0;
    for( var i = 0; i < count; i++ )
    { 
       if( (this.laundering_options.softeners[i].id).toString() == id.toString() ){
           return (this.laundering_options.softeners[i].title); 
       }
    }
    return '';  
  }

  getWhitenerstoValue(id = ''){
    var count = ( this.laundering_options.whiteners != undefined && this.laundering_options.whiteners ) ? this.laundering_options.whiteners.length : 0;
    for( var i = 0; i < count; i++ )
    { 
       if( (this.laundering_options.whiteners[i].id).toString() == id.toString() ){
           return (this.laundering_options.whiteners[i].title); 
       }
    }
    return '';  
  }

  paymentType(type = ''){
    if(type == '1'){
      return "Cash";
    }else{
      return "Online";
    }
  }

  ngOnInit() {

    this.route.queryParams
      .filter(params => params.page)
      .subscribe(params => {
        console.log(params); // {order: "popular"}

        this.page = params.page;
        console.log(this.page); // popular
        this.nextpage(this.page);
      });

    this.DAYS = environment.DAYS;
    this.TIME_RANGE = environment.TIME_RANGE;

    let sid = localStorage.getItem('sid');
    let order = {"sid":sid, "page":this.page}
    this.spinnerService.show();
    this.auth.laundering_options().then((user) => {
      console.log(user.json());
      let response = user.json();
      if(response.replyCode == "error"){
        this.spinnerService.hide();
        this.auth.open(response.replyMsg);
      }else{
        this.laundering_options = response.data;
        //this.spinnerService.hide();
        console.log("laundering_options", this.laundering_options)
      }
    })
    .then(()=>{
      this.auth.completed_order(order).then((order)=> {
        let response = order.json();
        if(response.replyCode == "error"){
          this.spinnerService.hide();
          this.auth.open(response.replyMsg);
        }else{
          this.completedData = response.data;
         // this.spinnerService.hide();
          console.log("completedData", this.completedData)
        }
      })
    })
    .then(()=>{
      this.auth.pending_order(order).then((order)=> {
        let response = order.json();
        if(response.replyCode == "error"){
          this.spinnerService.hide();
          this.auth.open(response.replyMsg);
        }else{
          console.log("response.data",response.data)
          if(response.data.pendingOrder.length == 0){
            this.pendingData = response.data.pauseBooking[0];
            if(this.pendingData)
              this.pendingData.order_status = 0;
          }else if(response.data.pendingOrder.length > 0){
            this.pendingData = response.data.pendingOrder[0];
          }else{
            this.pendingData = [];
          }
          
          this.spinnerService.hide();
          console.log("pendingData", this.pendingData)
        }
      })
    })
    .catch((err) => {
      this.spinnerService.hide();
      console.log(err);
      this.auth.open(environment.error)
    });




  }

  nextpage(page){
    console.log("dddd",this.route.snapshot.queryParamMap.get('page'));
    this.page = page;
    let sid = localStorage.getItem('sid');
    let order = {"sid":sid, "page":this.page}
    this.spinnerService.show();
    this.auth.completed_order(order).then((order)=> {
      let response = order.json();
      if(response.replyCode == "error"){
        this.spinnerService.hide();
        this.auth.open(response.replyMsg);
      }else{
        this.completedData = response.data;
        this.spinnerService.hide();
        console.log("completedData", this.completedData)
      }
    })
    .catch((err) => {
      this.spinnerService.hide();
      console.log(err);
      this.auth.open(environment.error)
    });
  }

  orderAction(type, bookingObject){
    let msg = '';
    let status = 0;
    if( type == 'cancel'){
     // msg = 'Are you sure, you want to cancel booking?';
      msg = 'Are you sure, you want to cancel order?';
      //status = 4;
      status = 3;
    }else if( type == 'pause' ){
      msg = 'Are you sure, you want to pause booking?';
      status = 2;
    }else if( type == 'resume' ){
      msg = 'Are you sure, you want to resume booking?';
      status = 1;
    }else if( type == 'cancelOrder' ){
      msg = 'Are you sure, you want to cancel order?';
      status = 3;
    }
 
    if(confirm(msg)) {
      let dataSubmit = {};
      let sid = localStorage.getItem('sid');
      if( status == 3 && typeof bookingObject.order_status != undefined && bookingObject.order_status == '1'){
        dataSubmit = { 'sid' : sid, "booking_id" : bookingObject.booking_id , "order_id" : bookingObject.order_no, "status" : status };
      }else{
        dataSubmit = { 'sid' : sid, "booking_id" : bookingObject.booking_id , "status" : status };
      }
      
      this.spinnerService.show();
      this.auth.booking_status_change(dataSubmit).then((order)=> {
        let response = order.json();
        if(response.replyCode == "error"){
          this.spinnerService.hide();
          this.auth.open(response.replyMsg);
        }else{
          this.spinnerService.hide();
        }
      })
      .then(()=>{
        let order = {"sid":sid, "page":0}
        this.auth.pending_order(order).then((order)=> {
          let response = order.json();
          if(response.replyCode == "error"){
            this.spinnerService.hide();
            this.auth.open(response.replyMsg);
          }else{
            if(response.data.pendingOrder.length == 0 || response.data.pauseBooking.length > 0){
              this.pendingData = response.data.pauseBooking[0];
              this.pendingData.order_status = 0;
            }else if(response.data.pendingOrder.length > 0){
              this.pendingData = response.data.pendingOrder[0];
            }
            this.spinnerService.hide();
          }
        })
      })
      .catch((err) => {
        this.spinnerService.hide();
        console.log(err);
        this.auth.open(environment.error)
      });
    }
  }

  orderReschedule(bookingObject){
    let msg = 'Are you sure, you want to reschedule order?';
    let status = 3;
    
 
    if(confirm(msg)) {
      let dataSubmit = {};
      let sid = localStorage.getItem('sid');
     
        dataSubmit = { 'sid' : sid, "booking_id" : bookingObject.booking_id , "order_id" : bookingObject.order_no, "status" : status };
      
      
      this.spinnerService.show();
      this.auth.booking_reschedule_change(dataSubmit).then((order)=> {
        let response = order.json();
        console.log("response",response);
        if(response.replyCode == "error"){
          this.spinnerService.hide();
          this.auth.open(response.replyMsg);
        }else{
          this.spinnerService.hide();
          this.router.navigate(['/place-order']);
        }
      })
      .catch((err) => {
        this.spinnerService.hide();
        console.log(err);
        this.auth.open(environment.error)
      });
    }
  }

  openreview(content, reviewOrder) {
    if(this.modalReference)
    this.modalReference.close();
    this.modalReference = this.modalService.open(content,  { windowClass: 'review-modal' });
    this.reviewOrderNo = reviewOrder;
  }

  reviewSubmit():void{
    console.log("dfdfd", this.reviewData)

    let sid = localStorage.getItem('sid');
    let order = {"sid":sid, "order_id":this.reviewOrderNo.order_no, ...this.reviewData}
    console.log("REview dagta", order)
    this.spinnerService.show();
    this.auth.booking_review(order).then((order)=> {
      let response = order.json();
      if(response.replyCode == "error"){
        this.spinnerService.hide();
        this.auth.open(response.replyMsg);
      }else{
        this.spinnerService.hide();
        this.reviewOrderNo.review = this.reviewData.review;
        this.reviewData = {};
        this.modalReference.close();
      }
    })
    .catch((err) => {
      this.spinnerService.hide();
      console.log(err);
      this.auth.open(environment.error)
    });
  }

  logout(){
    this.auth.changeLoginStatus(false);
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('sid');
   this.router.navigate(['/']);
 }

  showChoosedServiceName(dc_require = 0,is_laundry=0){
    let str = '';
    if(dc_require){
      str = 'Dry Cleaning';
    }

    if(is_laundry){
      if (str=='') {
        str += 'Laundry';
      } else {
        str += ', Laundry';
      }
      
    }

    return str;  
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/my-order/my-order.component.ts